import { CustomerType } from 'src/common/models/customerType';
import { createAction } from 'src/lib/createAction';

export const customerTypeActions = {
  setCustomerType: createAction(`app/setCustomerType`)<CustomerType>(),
} as const;
